import React from 'react';

const cx = (...c) => c.filter(Boolean).join(' ');

// Surface primitive. `hover` adds a subtle lift on pointer; `as` lets it be a
// link/section while keeping the visual treatment.
const Card = ({ as: Tag = 'div', hover = false, className, children, ...props }) => (
  <Tag
    className={cx(
      'bg-white rounded-2xl border border-ink-100 shadow-card',
      hover && 'transition-all duration-200 hover:shadow-lift hover:-translate-y-0.5',
      className
    )}
    {...props}
  >
    {children}
  </Tag>
);

export default Card;
